import React from 'react';

import Modal from 'react-bootstrap/Modal';
import FeedbackContent from '../../components/FeedbackContent';

import classes from './styles.module.scss';

export default function FeedbackModal({
  show,
  candidate,
  interview,
  job,
  refetch,
  existingFeedback = null,
  isReviewing = false,
  handleClose,
  readOnly = false,
}) {
  return (
    <Modal
      show={show}
      centered
      className={classes.FeedbackModal}
      backdropClassName={classes.backdrop}
      contentClassName={classes.modalContent}
      dialogClassName={classes.dialog}
    >
      <FeedbackContent
        candidate={candidate}
        interview={interview}
        job={job}
        refetch={refetch}
        existingFeedback={existingFeedback}
        isReviewing={isReviewing}
        onClose={handleClose}
        readOnly={readOnly}
        showHeader
        showCloseButton
      />
    </Modal>
  );
}
